import { createContext, FC, PropsWithChildren, useMemo } from "react";
import { useScript } from "lib/hooks/useScript";

const SWIPER_JS = "https://unpkg.com/swiper@8.1.4/swiper-bundle.min.js";
const SWIPER_CSS = "https://unpkg.com/swiper@8.1.4/swiper-bundle.min.css";
const JQUERY_JS = "/lp/js/kaleido/jquery-3.6.0.min.js"; // jquery-uiも含まれてる
const GSAP_JS = "https://cdnjs.cloudflare.com/ajax/libs/gsap/3.10.4/gsap.min.js";
const SCROLL_TRIGGER_JS = "https://cdnjs.cloudflare.com/ajax/libs/gsap/3.10.4/ScrollTrigger.min.js";

type ContextType = {
  swiper: boolean;
  jquery: boolean;
  gsap: boolean;
};
const initialContext: ContextType = {
  swiper: false,
  jquery: false,
  gsap: false,
};
export const LibraryContext = createContext<ContextType>(initialContext);
export const LibraryContextProvider: FC<PropsWithChildren<object>> = ({ children }) => {
  const swiperStatus = useScript(SWIPER_JS);
  const swiper = useMemo(() => swiperStatus === "ready", [swiperStatus]);
  const jqueryStatus = useScript(JQUERY_JS);
  const jquery = useMemo(() => jqueryStatus === "ready", [jqueryStatus]);
  const gsapStatus = useScript(GSAP_JS);
  const scrollTriggerStatus = useScript(SCROLL_TRIGGER_JS);
  const gsap = useMemo(() => {
    if (gsapStatus === "ready" && scrollTriggerStatus === "ready") {
      window.gsap.registerPlugin(window.ScrollTrigger);
      return true;
    } else {
      return false;
    }
  }, [gsapStatus, scrollTriggerStatus]);
  return (
    <LibraryContext.Provider value={{ swiper, jquery, gsap }}>
      <style global jsx>{`
        @import "${SWIPER_CSS}";
      `}</style>
      {children}
    </LibraryContext.Provider>
  );
};
